import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  getMicroStatusLogisticProviders({ commit, state }) {
    const { logisticProviderId } = state.filters;
    commit('toogleLoading', true);
    return Http.get(Url.toQueryString('api/v1/tracking/micro_state_mappings', null, [logisticProviderId]))
      .then((res) => {
        commit('toogleLoading', false);
        commit('setMicroStatusLogisticProviders', res.data.content.default);
      })
      .catch(() => {
        commit('toogleLoading', false);
      });
  },
  getMicroStatusShippers({ commit }) {
    commit('toogleLoading', true);
    return Http.get('api/v1/tracking/shipper_state_mappings')
      .then((res) => {
        commit('toogleLoading', false);
        commit('setMicroStatusShipping', res.data.content);
      })
      .catch(() => {
        commit('toogleLoading', false);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-micro-status/store/actions.js